import { render, staticRenderFns } from "./FeeDetailEdit.vue?vue&type=template&id=5687c19b&scoped=true"
import script from "./FeeDetailEdit.vue?vue&type=script&lang=js"
export * from "./FeeDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./FeeDetailEdit.vue?vue&type=style&index=0&id=5687c19b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687c19b",
  null
  
)

export default component.exports